<div class="all-data-filter-dialog">
  <div class="all-data-filter-dialog__header">
    {{header}}
    <button *ngIf="isNotEmpty" mat-flat-button
      class="all-data-filter-dialog__clear"
      [autofocus]="false"
      (click)="clear()"
    >
      Clear
      <mat-icon iconPositionEnd>delete</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="all-data-filter-dialog__body">
    <app-all-data-date-filter *ngIf="type === 'DATE'"
      [data]="data"
      [onClear]="onClearSubject"
      (dateFilterChange)="filterChange($event)"
    />
    <app-all-data-year-filter *ngIf="type === 'YEAR'"
      [data]="data"
      [onClear]="onClearSubject"
      (yearFilterChange)="filterChange($event)"
    />
    <app-all-data-time-filter *ngIf="type === 'TIME'"
      [data]="data"
      [onClear]="onClearSubject"
      (timeFilterChange)="filterChange($event)"
    />
    <app-all-data-select-filter *ngIf="type === 'SELECT'"
      [data]="data"
      [isSingle]="isSingle"
      [options]="$any(options)"
      [placeholder]="header"
      [onClear]="onClearSubject"
      (filterChange)="filterChange($event)"
    />
    <app-multiselect-with-search *ngIf="type === 'AUTOCOMPLETE'"
      [placeholder]="header"
      [options]="$any(options)"
      [(ngModel)]="data"
      (ngModelChange)="filterChange($event)"
    />
    <app-all-data-text-filter *ngIf="type === 'TEXT'"
      [data]="data"
      [onClear]="onClearSubject"
      (filterChange)="filterChange($event)"
    />
  </div>
  <mat-divider></mat-divider>
  <div class="all-data-filter-dialog__footer">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button color="primary" (click)="onApply()">Apply</button>
  </div>
</div>
